import { css } from "@emotion/react"
import styled from "@emotion/styled"
import { BasicFormItemMap } from "./components/form_item_map"
import ButtonRegular from "@/components/composite/ButtonRegular/main"
import { kycForm } from "@/forms"
import { CustomError } from "@/utils/error"
import { createLogger } from "@/utils/logger"
import { useEffect } from "react"
import { computed } from "@preact/signals"
import KycPageSignals from "@/features_signal/kyc/kycPageSignals"
import { useNavigate } from "react-router-dom"
import ModalSlideUp from "@/components/composite/ModalSlideUp/main"
const logger = createLogger("StepKycBasicInformationForm")

const Container = styled.div`
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: stretch;
    justify-content: flex-start;
    font-family: "Gilroy";
    background: #f2f2f3;
    gap: 8rem;
    overflow-y: scroll;
    position: relative;
`

const SubmitButton = styled(ButtonRegular)``

export default function StepKycBasicInformationForm() {
    const methods = kycForm.useFormContext()
    const navigate = useNavigate()

    useEffect(() => {
        KycPageSignals.fetchKyc()
        return () => {
            KycPageSignals.fixedCurrentStage.value = null
        }
    }, [])

    useEffect(() => {
        return () => {
            methods.setError("root", {
                message: "",
            })
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const isSubmitShow = computed(() => {
        switch (KycPageSignals.currentStatus.value) {
            case "unset":
            case "basic_account":
            case "under_review":
            case "rejected":
            case "basic_kyc":
            case "fully_kyc":
            case "frozen":
            case "block":
            case "test_account":
                return true
            default:
                return false
        }
    })

    return (
        <Container>
            <FormSection title="Basic Information">
                <BasicFormItemMap.FirstName />
                <BasicFormItemMap.MiddleName />
                <BasicFormItemMap.LastName />
                <BasicFormItemMap.DateOfBirth />
                <BasicFormItemMap.Gender />
                <BasicFormItemMap.idFrontPhoto />
                <BasicFormItemMap.idBackPhoto />
                <BasicFormItemMap.selfieWithIdPhoto />
            </FormSection>
            <div
                css={css`
                    box-sizing: border-box;
                    z-index: 100;
                    position: sticky;
                    bottom: 0;
                    display: flex;
                    flex-direction: column;
                    align-items: stretch;
                    justify-content: center;
                    background-color: #ffffff;
                    padding: 16rem 24rem 20rem 16rem;
                `}
            >
                {isSubmitShow.value && (
                    <SubmitButton
                        disabled={KycPageSignals.isSubmittingKyc.value}
                        onClick={() => {
                            methods.handleSubmit(async (data) => {
                                logger.debug("data", data)
                                try {
                                    await KycPageSignals.updateBasicInformation(data)
                                    navigate(-1)
                                } catch (error) {
                                    if (error instanceof CustomError) {
                                        logger.debug(error.message)
                                        methods.setError("root", {
                                            message: error.message,
                                        })
                                    } else {
                                        logger.debug("error", error)
                                    }
                                }
                            })()
                        }}
                    >
                        Submit
                    </SubmitButton>
                )}
            </div>
            <ModalSlideUp familyName="BaseImageUploader" />
        </Container>
    )
}

function FormSection(props: { title: string; children: React.ReactNode }) {
    return (
        <div
            css={css`
                display: flex;
                flex-direction: column;
                align-items: stretch;
                justify-content: flex-start;
                padding: 16rem 24rem;
                background-color: #ffffff;
            `}
        >
            <div
                css={css`
                    font-weight: 600;
                    font-size: 16rem;
                    line-height: 24rem;
                    letter-spacing: 0%;
                    vertical-align: middle;
                    text-transform: capitalize;
                    color: #747378;
                `}
            >
                {props.title}
            </div>
            <div
                css={css`
                    margin-top: 16rem;
                `}
            />
            <div
                css={css`
                    display: flex;
                    flex-direction: column;
                    align-items: stretch;
                    justify-content: flex-start;
                    gap: 16rem;
                `}
            >
                {props.children}
            </div>
        </div>
    )
}
